var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertInfoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.6663C10.81 36.6663 3.33337 29.1897 3.33337 19.9997C3.33337 10.8097 10.81 3.33301 20 3.33301C29.19 3.33301 36.6667 10.8097 36.6667 19.9997C36.6667 29.1897 29.19 36.6663 20 36.6663ZM20 4.99967C11.729 4.99967 5.00004 11.7286 5.00004 19.9997C5.00004 28.2707 11.729 34.9997 20 34.9997C28.2711 34.9997 35 28.2707 35 19.9997C35 11.7286 28.2711 4.99967 20 4.99967ZM18.5209 13.1455C18.5209 12.333 19.1875 11.6663 20 11.6663C20.8334 11.6663 21.4792 12.3122 21.4792 13.1455C21.4792 13.9788 20.8334 14.6247 20 14.6247C19.1875 14.6247 18.5209 13.958 18.5209 13.1455ZM18.9063 16.7497H21.0938V28.333H18.9063V16.7497Z",
    fill: "#007BC0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfoBlue);
export default __webpack_public_path__ + "static/media/alert-info-blue.54acc3acd0ec298dd51d68614ae8b761.svg";
export { ForwardRef as ReactComponent };